import React, { Component } from 'react';
import { connect } from 'react-redux';
import { types } from 'actions/polls/types';
import HeaderTemplate from 'templates/HeaderTemplate/HeaderTemplate';
import Container from '@material-ui/core/Container';
import BoxWrapper from 'components/atoms/BoxWrapper';
import Grid from '@material-ui/core/Grid';
import CustomTypography from 'components/atoms/CustomTypography';
import { Redirect } from 'react-router';
import { routes } from 'routes/Routes';
import { Link } from 'react-router-dom';
import { colors, fonts } from '../../../theme/Variables';
import styled from 'styled-components';

const StyledDefaultLink = styled.a`
    color: ${colors.primary[700]};
    font-weight: bold;
    &:active, &:hover, &:visited, &:focus {
        color: ${colors.primary[700]};
    }
`;

const StyledLink = styled(Link)`
    color: ${colors.primary[700]};
    font-weight: bold;
    &:active, &:hover, &:visited, &:focus {
        color: ${colors.primary[700]};
    }
`;

class Successful extends Component {
    constructor(props) {
        super(props);

        this.props = props;
        this.dispatch = props.dispatch;
    }

    componentWillUnmount() {
        this.dispatch({ type: types.VERIFY_TOKEN_FOR_POLL_REQUEST, payload: false });
        this.dispatch({ type: types.VERIFY_TOKEN_FOR_POLL_SUCCESS, payload: false });
        this.dispatch({ type: types.VERIFY_TOKEN_FOR_POLL_FAILURE, payload: false });
    }

    render() {
        return(
            <>
                <HeaderTemplate title="Today's Poll" />
                <Container>
                    <BoxWrapper mt="50">
                        <Grid container justify="center">
                            <Grid item xs={12} md={4}>
                                <BoxWrapper mb="20" mt="20" justifyContent="flex-start">
                                    <CustomTypography
                                        variant="h3"
                                        fontSize="2.6"
                                        customfont={fonts.secondary}
                                    >
                                        Today's Poll
                                    </CustomTypography>
                                </BoxWrapper>
                                <BoxWrapper mb="20" mt="20" justifyContent="flex-start">
                                    <CustomTypography>
                                        Sorry, it looks like you have already completed today’s poll. Why not take a look at our <StyledDefaultLink href="https://www.mobiliseonline.co.uk/blog" target="_blank">latest articles.</StyledDefaultLink>
                                    </CustomTypography>
                                </BoxWrapper>
                                <BoxWrapper mb="45" justifyContent="flex-start">
                                    <CustomTypography>
                                        If you have been forwarded this by a friend and would like to complete this for yourself, you can <StyledLink to={routes.registerRoute}>register to receive Mobilise Moments today</StyledLink>.
                                    </CustomTypography>
                                </BoxWrapper>
                            </Grid>
                        </Grid>
                    </BoxWrapper>
                </Container>
            </>
        )
    }
}

const mapStateToProps = ({ polls }) => {
    return { polls };
}

export default connect(mapStateToProps, null)(Successful);
